import { render, staticRenderFns } from "./ScannerListItem.vue?vue&type=template&id=395af356&scoped=true&"
import script from "./ScannerListItem.vue?vue&type=script&lang=js&"
export * from "./ScannerListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395af356",
  null
  
)

export default component.exports